import React, { useState } from "react";
import { ArrowRightIcon, CheckIcon } from "lucide-react";
import { sessions, situations } from "../data/landing";
export function SituationSelector() {
  const [selected, setSelected] = useState(0);
  const choice = situations[selected];
  const sessionNumber = String(choice.sessionIndex + 1).padStart(2, "0");
  return <section className="section" id="find-your-session" data-id="element-190" data-mp="2m6nu3ipuqmui">
      <div className="shell" data-id="element-191" data-mp="1ok6w0b9ao57p">
        <div className="section-intro" data-id="element-192" data-mp="1ol9ouoq6ghq9">
          <p className="eyebrow" data-id="element-193" data-mp="1tiro1nee7il2">START WITH THE CONVERSATION YOUR TEAM FACES</p>
          <h2 data-id="element-194" data-mp="1tgp1jdcg87l3">Which customer conversation needs practice?</h2>
          <p data-id="element-195" data-mp="1ygtggyxpku97">You know where the team gets stuck. Choose a situation and start with a session built around it.</p>
        </div>
        <div className="finder-grid" data-id="element-196" data-mp="239w3spbw77gy">
          <div className="finder-options" role="group" aria-label="Choose a customer conversation" data-id="element-197" data-mp="15tgtinnmykfd">
            {situations.map((item, i) => <button key={item.label} type="button" aria-pressed={selected === i} aria-controls="session-match" onClick={() => setSelected(i)} data-id="element-198" data-mp="1aqpesx42z4ku" data-mpi={i}>
                <span data-id="element-199" data-mp="3h6jpq314dtsa">{item.label}</span>
                <ArrowRightIcon size={19} aria-hidden="true" data-id="element-200" data-mp="3h5i26z2x3eto" />
              </button>)}
          </div>
          <div className="finder-result" id="session-match" aria-live="polite" aria-atomic="true" data-id="element-201" data-mp="3d4gbx7qzad3u">
            <p className="eyebrow" data-id="element-202" data-mp="387g52umb16bo">YOUR STARTING POINT · SESSION {sessionNumber}</p>
            <h3 data-id="element-203" data-mp="335qpr2s1u6hs">{sessions[choice.sessionIndex].title}</h3>
            <p data-id="element-204" data-mp="2y7payu1notc4">{choice.prompt}</p>
            <div className="outcome" data-id="element-205" data-mp="2y8qlmxerfdtb">
              <CheckIcon size={21} aria-hidden="true" data-id="element-206" data-mp="2y9rxh43lo4c3" />
              <div data-id="element-207" data-mp="2u6vnu2w1fika">
                <strong data-id="element-208" data-mp="2u7f1h7ennksi">What your team practices</strong>
                <p data-id="element-209" data-mp="wg2eicyzw689">{choice.practice}</p>
              </div>
            </div>
            <a className="text-link" href="#workshops" data-id="element-210" data-mp="wdzpnw9kwj54">
              Explore all 10 sessions <ArrowRightIcon size={16} aria-hidden="true" data-id="element-211" data-mp="sfig762oqwkj" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}